enum WarehouseParameterLimitTypeEnum {
    Maximum = 'MAXIMUM',
    Minimum = 'MINIMUM',
}

export default WarehouseParameterLimitTypeEnum;
